import ChooseBankAccountModal from './ChooseBankAccountModal';

export default ChooseBankAccountModal;


// WEBPACK FOOTER //
// ./src/components/ChooseBankAccountModal/index.jsx